import React from "react";
import SingleCounter from "../../components/Widgets/SingleCounter";
import WebView from "../../components/Widgets/WebView/webview";
import Banner from "../../components/Widgets/Banner/banner";
import Tile from "../../components/Widgets/Tile/Tile";
import { getWidgetType } from "../../utils/helpers";
const widgetMapping = {
  banner: Banner,
  singlecounter: SingleCounter,
  webview: WebView,
  tile: Tile,
};

const WidgetWrapper = ({ data }) => {
  if (!data) {
    return <h1>Widget not found</h1>;
  }
  const widgetType = getWidgetType(data.config);
  if (!widgetType) {
    return <h1>Widget not found</h1>;
  }
  const Widget = widgetMapping[widgetType];

  return Widget ? (
    <Widget widgetInformation={data} />
  ) : (
    <h1>Widget not found</h1>
  );
};

export default WidgetWrapper;
